import { useMutation } from '@tanstack/react-query';
import * as userServices from 'services/user';

export const useCreateUserLocationFromCompany = ({
  onSuccess,
  onError,
} = {}) => {
  return useMutation({
    mutationFn: (params) => userServices.createUserLocationFromCompany(params),
    onSuccess,
    onError,
  });
};
